import { FC } from 'react';
import { If, SceneWrapper } from '~/components';
import { type IconProp } from '~/modules';
import {
  ButtonComponent,
  ContentWrapper,
  Description,
  FooterContainer,
  IconComponent,
  Title,
} from './styles';

interface ErrorSceneProps {
  title: string;
  subtitle?: string;
  icon?: IconProp;
  primaryButton?: {
    text?: string;
    onPress?: () => void;
  };
  secondaryButton?: {
    text?: string;
    onPress?: () => void;
  };
  isLoading?: boolean;
}

const ErrorScene: FC<ErrorSceneProps> = ({
  title,
  subtitle,
  icon,
  primaryButton,
  secondaryButton,
  isLoading,
}) => {
  const getFooter = () => {
    if (!primaryButton?.text && !secondaryButton?.text) {
      return null;
    }
    return (
      <If condition={!!primaryButton?.text || !!secondaryButton?.text}>
        <FooterContainer>
          <If condition={!!primaryButton?.text}>
            <ButtonComponent
              fullWidth
              id="primary-error-scene-button"
              onPress={primaryButton?.onPress || (() => {})}
              onLoading={isLoading}
              transparent
            >
              {primaryButton?.text}
            </ButtonComponent>
          </If>
          <If condition={!!secondaryButton?.text}>
            <ButtonComponent
              fullWidth
              id="secondary-error-scene-button"
              onPress={secondaryButton?.onPress || (() => {})}
              onLoading={isLoading}
            >
              {secondaryButton?.text}
            </ButtonComponent>
          </If>
        </FooterContainer>
      </If>
    );
  };
  return (
    <SceneWrapper footer={getFooter()}>
      <ContentWrapper>
        <If condition={!!icon}>
          <IconComponent icon={icon as IconProp} />
        </If>
        <Title>{title}</Title>
        <If condition={!!subtitle}>
          <Description>{subtitle}</Description>
        </If>
      </ContentWrapper>
    </SceneWrapper>
  );
};

export default ErrorScene;
